import axios from "axios";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import Offcanvas from "react-bootstrap/Offcanvas";
import Select from "react-select";
import { adminMainUrl } from "../../../../../../../Config";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { getCCJobOrderImportShipmentDetail } from "../../../../../../../Redux/action/CustomClearance/CCImportAction";

const EditShipment = ({
  addShow,
  handleAddClose,
  token,
  user_id,
  b64id,
  trans_mode,
  refresh,
  loadingCCImportJobCurrencyList,
  currencyOptions,
  shipment_id
}) => {

  const dispatch = useDispatch();
  const [disableSubmit, setDisableSubmit] = useState(false);


  useEffect(() => {
    if (token && user_id && b64id && (shipment_id && shipment_id != 0)) {
      let id = atob(b64id);
      if (id) {
        dispatch(getCCJobOrderImportShipmentDetail(token, user_id, id, shipment_id))
      }
    }
  }, [shipment_id]);

  const {
    loadingCCImportJobShipmentDetail,
    CCImportJobShipmentDetailData,
    CCImportJobShipmentDetailDataError,
  } = useSelector(state => state?.CCImportReducer);




  const initialValues = {
    custom_clearance_import_job_id: "",
    shipment_no: "",
    shipment_date: "",
    TOI_type: "",
    TOI_place: "",
    currency_type: "",
    currency_amount: "",
    price_includes: "",
    taxable_value_for_IGST: "",
    shipment_value: "",
    product_value: "",
    packing_FOB: ""
  }

  const formik = useFormik({
    initialValues: initialValues,
    onSubmit: (values,{resetForm}) => {
      // console.log(values);
      setDisableSubmit(true);
      try {
        let config = {
          headers: {
            'auth-token': token,
            'user_id': user_id
          }
        };

        values.custom_clearance_import_job_id = atob(b64id);
        values.id = shipment_id
        axios.post(`${adminMainUrl}/api/customClearance/import/shipment/update`, values, config)
          .then(response => {
            if (response.status == 200) {
              toast.success(response?.data?.msg);
              setDisableSubmit(false);
              handleAddClose();
              // resetForm();
              refresh();
            } else {
              toast.error(response?.data?.msg);
              setDisableSubmit(false);
            }
          }).catch(error => {
            console.log(error);
            let msg = "Internal server error!";
            if (error.response && error.response.data && error.response.data.msg) {
              msg = error.response.data.msg
            }
            toast.error(msg);
            setDisableSubmit(false);
          })
      } catch (error) {
        console.log(error.message);
        toast.error(error.message);
        setDisableSubmit(false);
      }
    }
  });

  // console.log("first", initialValues)

  const [showLoader, setShowLoader] = useState(false);
  useEffect(() => {
    if (loadingCCImportJobShipmentDetail) {
      setShowLoader(true);
    } else {
      setShowLoader(false);
    }

    if (CCImportJobShipmentDetailData) {
      formik.setFieldValue("airline_id", CCImportJobShipmentDetailData?.airline_id);
      formik.setFieldValue("voyage_no", CCImportJobShipmentDetailData?.voyage_no);
      formik.setFieldValue("vessel_sailing_date", CCImportJobShipmentDetailData?.vessel_sailing_date);
      formik.setFieldValue("vessel_sailing_name", CCImportJobShipmentDetailData?.vessel_sailing_name);
      formik.setFieldValue("shipping_line_id", Number(CCImportJobShipmentDetailData?.shipping_line_id));
      formik.setFieldValue("flight_date", CCImportJobShipmentDetailData?.flight_date);
      formik.setFieldValue("flight_No", CCImportJobShipmentDetailData?.flight_No);
      formik.setFieldValue("gross_weight_type", CCImportJobShipmentDetailData?.gross_weight_type);
      formik.setFieldValue("gross_weight", CCImportJobShipmentDetailData?.gross_weight);
      formik.setFieldValue("EGM_No", CCImportJobShipmentDetailData?.EGM_No);
      formik.setFieldValue("EGM_Date", CCImportJobShipmentDetailData?.EGM_Date);
      formik.setFieldValue("MAWB_No", CCImportJobShipmentDetailData?.MAWB_No);
      formik.setFieldValue("MAWB_Date", CCImportJobShipmentDetailData?.MAWB_Date);
      formik.setFieldValue("HAWB_No", CCImportJobShipmentDetailData?.HAWB_No);
      formik.setFieldValue("HAWB_Date", CCImportJobShipmentDetailData?.HAWB_Date);
      formik.setFieldValue("net_weight", CCImportJobShipmentDetailData?.net_weight);
      formik.setFieldValue("net_weight_type", CCImportJobShipmentDetailData?.net_weight_type);
      formik.setFieldValue("volume_weight", CCImportJobShipmentDetailData?.volume_weight);
      formik.setFieldValue("volume_weight_type", CCImportJobShipmentDetailData?.volume_weight_type);
      formik.setFieldValue("chargeable_weight", CCImportJobShipmentDetailData?.chargeable_weight);
      formik.setFieldValue("chargeable_weight_type", CCImportJobShipmentDetailData?.chargeable_weight_type);
      formik.setFieldValue("place_of_receipt", CCImportJobShipmentDetailData?.place_of_receipt);
      formik.setFieldValue("transhipper_code", CCImportJobShipmentDetailData?.transhipper_code);
      formik.setFieldValue("marks_Note", CCImportJobShipmentDetailData?.marks_Note);
    }
  }, [loadingCCImportJobShipmentDetail, CCImportJobShipmentDetailData]);

  const customStyles = {
    control: (base) => ({
      ...base,
      height: 29,
      minHeight: 29,
      display: 'flex',
      alignItems: 'center',
    }),
    placeholder: (base) => ({
      ...base,
      display: 'flex',
      alignItems: 'center',
      fontSize: '12px',
      fontWeight: "600",
      color: '#808080',
    }),
    menu: (base) => ({
      ...base,
      fontSize: '12px',
    }),
    option: (base) => ({
      ...base,
      fontSize: '12px',
    }),
    singleValue: (base) => ({
      ...base,
      fontSize: '12px',
      display: 'flex', // Ensure singleValue aligns center vertically
      alignItems: 'center',
    }),
  };


  return (
    <>
      <Offcanvas show={addShow} onHide={handleAddClose} placement={"end"}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Edit Shipment</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
        {trans_mode == "Air" &&
        <>
        <form onSubmit={formik.handleSubmit}>
            <div className="row">
            <div className="col-md-6 mt-2">
              <label htmlFor="pickuptype" className="form-label ">
              Airline
              </label>
              <input name="airline_id"
                  id="airline_id"
                  maxLength={250}
                  className="form-control form-control-sm "
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.airline_id}
                  onInput={(event) => {
                    let value = event.target.value;
                    value = value.replace(/[^0-9]/g, '');
                    event.target.value = value;
                  }}
              />
            </div>
            <div className="col-md-6 mt-2">
              <label htmlFor="pickuptype" className="form-label ">
              Flight No
              </label>
              <input name="flight_No"
                  id="flight_No"
                  maxLength={250}
                  className="form-control form-control-sm "
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.flight_No}
                  onInput={(event) => {
                    let value = event.target.value;
                    value = value.replace(/[^0-9]/g, '');
                    event.target.value = value;
                  }}
              />
            </div>
            <div className="col-md-6 mt-2">
              <label htmlFor="pickuptype" className="form-label ">
              Flight / Inward Date
              </label>
              <input name="flight_date"
                  id="flight_date"
                  type="date"
                  maxLength={250}
                  className="form-control form-control-sm "
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.flight_date}
                  onInput={(event) => {
                    let value = event.target.value;
                    value = value.replace(/[^0-9]/g, '');
                    event.target.value = value;
                  }}
              />
            </div>
            <div className="col-md-6 mt-2">
              <label htmlFor="pickuptype" className="form-label ">
              IGM No
              </label>
              <input name="EGM_No"
                  id="EGM_No"
                  maxLength={250}
                  className="form-control form-control-sm "
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.EGM_No}
                  onInput={(event) => {
                    let value = event.target.value;
                    value = value.replace(/[^0-9]/g, '');
                    event.target.value = value;
                  }}
              />
            </div>
            <div className="col-md-6 mt-2">
              <label htmlFor="pickuptype" className="form-label ">
              IGM Date 
              </label>
              <input name="EGM_Date"
                  id="EGM_Date"
                  type="date"
                  maxLength={250}
                  className="form-control form-control-sm "
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.EGM_Date}
                  onInput={(event) => {
                    let value = event.target.value;
                    value = value.replace(/[^0-9]/g, '');
                    event.target.value = value;
                  }}
              />
            </div>
            <div className="col-md-6 mt-2">
              <label htmlFor="pickuptype" className="form-label ">
              MAWB No 
              </label>
              <input name="MAWB_No"
                  id="MAWB_No"
                  maxLength={250}
                  className="form-control form-control-sm "
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.MAWB_No}
                  onInput={(event) => {
                    let value = event.target.value;
                    value = value.replace(/[^0-9]/g, '');
                    event.target.value = value;
                  }}
              />
            </div>
            <div className="col-md-6 mt-2">
              <label htmlFor="pickuptype" className="form-label ">
              MAWB Date
              </label>
              <input name="MAWB_Date"
                  id="MAWB_Date"
                  type="date"
                  maxLength={250}
                  className="form-control form-control-sm "
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.MAWB_Date}
                  onInput={(event) => {
                    let value = event.target.value;
                    value = value.replace(/[^0-9]/g, '');
                    event.target.value = value;
                  }}
              />
            </div>
            <div className="col-md-6 mt-2">
              <label htmlFor="pickuptype" className="form-label ">
              HAWB No
              </label>
              <input name="HAWB_No"
                  id="HAWB_No"
                  maxLength={250}
                  className="form-control form-control-sm "
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.HAWB_No}
                  onInput={(event) => {
                    let value = event.target.value;
                    value = value.replace(/[^0-9]/g, '');
                    event.target.value = value;
                  }}
              />
            </div>
            <div className="col-md-6 mt-2">
              <label htmlFor="pickuptype" className="form-label ">
              HAWB Date
              </label>
              <input name="HAWB_Date"
                  id="HAWB_Date"
                  type="date"
                  maxLength={250}
                  className="form-control form-control-sm "
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.HAWB_Date}
                  onInput={(event) => {
                    let value = event.target.value;
                    value = value.replace(/[^0-9]/g, '');
                    event.target.value = value;
                  }}
              />
            </div>
            <div className="col-md-6 mt-2">
              <label htmlFor="pickuptype" className="form-label ">
              Gross Wt 
              </label>
              <div className="d-flex gap-2">
              <input name="gross_weight"
                  id="gross_weight"
                  maxLength={250}
                  className="form-control form-control-sm "
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.gross_weight}
                  onInput={(event) => {
                    let value = event.target.value;
                    value = value.replace(/[^0-9]/g, '');
                    event.target.value = value;
                  }}
              />
              <select
                    className="form-control form-control-sm ms-2"
                    id="gross_weight_type"
                    name="gross_weight_type"
                    onChange={(e) => {
                      formik.setFieldValue("gross_weight_type", e.target.value);
                    }}
                    value={formik.values.gross_weight_type}
                  >
                    <option value="" disabled>-</option>
                    <option value="NOS">NOS</option>
                    <option value="BAG">BAG (Bags)</option>
                    <option value="BGS">BGS (BAGS)</option>
                    <option value="BLK">BLK (Bulk)</option>
                    <option value="BLO">BLO (Steel Blocks)</option>
                    <option value="BLS">BLS (Bails)</option>
                    <option value="BOX">BOX (Boxes)</option>
                    <option value="BRL">BRL (Barrel)</option>
                    <option value="BTL">BTL (Bottles)</option>
                    <option value="BUL">BUL (Steel Bulk)</option>
                    <option value="CAN">CAN (Cans)</option>
                    <option value="CHI">CHI (Chest)</option>
                    <option value="COL">COL (Collies)</option>
                    <option value="CON">CON (Container)</option>
                    <option value="CRI">CRI (Crates)</option>
                    <option value="CRY">CRY (Carboys)</option>
                    <option value="CSK">CSK (Wooden Cases)</option>
                    <option value="CTN">CTN (Cartons)</option>
                    <option value="CYL">CYL (Cylinder)</option>
                    <option value="DOZ">DOZ (Dozen)</option>
                    <option value="DRM">DRM (Drums)</option>
                    <option value="ENV">ENV (Steel Envelopes)</option>
                    <option value="FBK">FBK (Habbuck)</option>
                    <option value="FLK">FLK (Flask)</option>
                    <option value="FUT">FUT (Futs)</option>
                    <option value="GRS">GRS (Gross)</option>
                  </select>
              </div>
            </div>
            <div className="col-md-6 mt-2">
              <label htmlFor="pickuptype" className="form-label ">
              Net Wt
              </label>
              <div className="d-flex gap-2">
              <input name="net_weight"
                  id="net_weight"
                  maxLength={250}
                  className="form-control form-control-sm "
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.net_weight}
                  onInput={(event) => {
                    let value = event.target.value;
                    value = value.replace(/[^0-9]/g, '');
                    event.target.value = value;
                  }}
              />
              <select
                    className="form-control form-control-sm ms-2"
                    id="net_weight_type"
                    name="net_weight_type"
                    onChange={(e) => {
                      formik.setFieldValue("net_weight_type", e.target.value);
                    }}
                    value={formik.values.net_weight_type}
                  >
                    <option value="" disabled>-</option>
                    <option value="NOS">NOS</option>
                    <option value="BAG">BAG (Bags)</option>
                    <option value="BGS">BGS (BAGS)</option>
                    <option value="BLK">BLK (Bulk)</option>
                    <option value="BLO">BLO (Steel Blocks)</option>
                    <option value="BLS">BLS (Bails)</option>
                    <option value="BOX">BOX (Boxes)</option>
                    <option value="BRL">BRL (Barrel)</option>
                    <option value="BTL">BTL (Bottles)</option>
                    <option value="BUL">BUL (Steel Bulk)</option>
                    <option value="CAN">CAN (Cans)</option>
                    <option value="CHI">CHI (Chest)</option>
                    <option value="COL">COL (Collies)</option>
                    <option value="CON">CON (Container)</option>
                    <option value="CRI">CRI (Crates)</option>
                    <option value="CRY">CRY (Carboys)</option>
                    <option value="CSK">CSK (Wooden Cases)</option>
                    <option value="CTN">CTN (Cartons)</option>
                    <option value="CYL">CYL (Cylinder)</option>
                    <option value="DOZ">DOZ (Dozen)</option>
                    <option value="DRM">DRM (Drums)</option>
                    <option value="ENV">ENV (Steel Envelopes)</option>
                    <option value="FBK">FBK (Habbuck)</option>
                    <option value="FLK">FLK (Flask)</option>
                    <option value="FUT">FUT (Futs)</option>
                    <option value="GRS">GRS (Gross)</option>
                  </select>
              </div>
            </div>
            <div className="col-md-6 mt-2">
              <label htmlFor="pickuptype" className="form-label ">
              Volume
              </label>
              <div className="d-flex gap-2">
              <input name="volume_weight" 
                  id="volume_weight"
                  maxLength={250}
                  className="form-control form-control-sm "
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.volume_weight}
                  onInput={(event) => {
                    let value = event.target.value;
                    value = value.replace(/[^0-9]/g, '');
                    event.target.value = value;
                  }}
              />
              <select
                    className="form-control form-control-sm ms-2"
                    id="volume_weight_type"
                    name="volume_weight_type"
                    onChange={(e) => {
                      formik.setFieldValue("volume_weight_type", e.target.value);
                    }}
                    value={formik.values.volume_weight_type}
                  >
                    <option value="" disabled>-</option>
                    <option value="NOS">NOS</option>
                    <option value="BAG">BAG (Bags)</option>
                    <option value="BGS">BGS (BAGS)</option>
                    <option value="BLK">BLK (Bulk)</option>
                    <option value="BLO">BLO (Steel Blocks)</option>
                    <option value="BLS">BLS (Bails)</option>
                    <option value="BOX">BOX (Boxes)</option>
                    <option value="BRL">BRL (Barrel)</option>
                    <option value="BTL">BTL (Bottles)</option>
                    <option value="BUL">BUL (Steel Bulk)</option>
                    <option value="CAN">CAN (Cans)</option>
                    <option value="CHI">CHI (Chest)</option>
                    <option value="COL">COL (Collies)</option>
                    <option value="CON">CON (Container)</option>
                    <option value="CRI">CRI (Crates)</option>
                    <option value="CRY">CRY (Carboys)</option>
                    <option value="CSK">CSK (Wooden Cases)</option>
                    <option value="CTN">CTN (Cartons)</option>
                    <option value="CYL">CYL (Cylinder)</option>
                    <option value="DOZ">DOZ (Dozen)</option>
                    <option value="DRM">DRM (Drums)</option>
                    <option value="ENV">ENV (Steel Envelopes)</option>
                    <option value="FBK">FBK (Habbuck)</option>
                    <option value="FLK">FLK (Flask)</option>
                    <option value="FUT">FUT (Futs)</option>
                    <option value="GRS">GRS (Gross)</option>
                  </select>
              </div>
            </div>
            <div className="col-md-6 mt-2">
              <label htmlFor="pickuptype" className="form-label ">
              Chargeable Wt
              </label>
              <div className="d-flex gap-2">
              <input name="chargeable_weight"
                  id="chargeable_weight"
                  maxLength={250}
                  className="form-control form-control-sm "
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.chargeable_weight}
                  onInput={(event) => {
                    let value = event.target.value;
                    value = value.replace(/[^0-9]/g, '');
                    event.target.value = value;
                  }}
              />
              <select
                    className="form-control form-control-sm ms-2"
                    id="chargeable_weight_type"
                    name="chargeable_weight_type"
                    onChange={(e) => {
                      formik.setFieldValue("chargeable_weight_type", e.target.value);
                    }}
                    value={formik.values.chargeable_weight_type}
                  >
                    <option value="" disabled>-</option>
                    <option value="NOS">NOS</option>
                    <option value="BAG">BAG (Bags)</option>
                    <option value="BGS">BGS (BAGS)</option>
                    <option value="BLK">BLK (Bulk)</option>
                    <option value="BLO">BLO (Steel Blocks)</option>
                    <option value="BLS">BLS (Bails)</option>
                    <option value="BOX">BOX (Boxes)</option>
                    <option value="BRL">BRL (Barrel)</option>
                    <option value="BTL">BTL (Bottles)</option>
                    <option value="BUL">BUL (Steel Bulk)</option>
                    <option value="CAN">CAN (Cans)</option>
                    <option value="CHI">CHI (Chest)</option>
                    <option value="COL">COL (Collies)</option>
                    <option value="CON">CON (Container)</option>
                    <option value="CRI">CRI (Crates)</option>
                    <option value="CRY">CRY (Carboys)</option>
                    <option value="CSK">CSK (Wooden Cases)</option>
                    <option value="CTN">CTN (Cartons)</option>
                    <option value="CYL">CYL (Cylinder)</option>
                    <option value="DOZ">DOZ (Dozen)</option>
                    <option value="DRM">DRM (Drums)</option>
                    <option value="ENV">ENV (Steel Envelopes)</option>
                    <option value="FBK">FBK (Habbuck)</option>
                    <option value="FLK">FLK (Flask)</option>
                    <option value="FUT">FUT (Futs)</option>
                    <option value="GRS">GRS (Gross)</option>
                  </select>
              </div>
            </div>
            <div className="col-md-6 mt-2">
              <label htmlFor="pickuptype" className="form-label ">
              Marks & Nos
              </label>
              <input name="marks_Note"
                  id="marks_Note"
                  maxLength={250}
                  className="form-control form-control-sm "
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.marks_Note}
                  onInput={(event) => {
                    let value = event.target.value;
                    value = value.replace(/[^0-9]/g, '');
                    event.target.value = value;
                  }}
              />
            </div>
          </div>

            <div className="row d-flex justify-content-end mt-2">
              <div className="col-md-6 d-flex justify-content-end">
                <button type="submit" className="btn btn-sm btn-danger" disabled={disableSubmit}>
                  {disableSubmit ? <><i className="fas fa-spinner fa-spin"></i> Saving...</> : "Add"}
                </button>
              </div>
            </div>
          </form>
        </>
}
        {trans_mode == "Sea" &&
        <>
        <form onSubmit={formik.handleSubmit}>
            <div className="row">
            <div className="col-md-6 mt-2">
              <label htmlFor="pickuptype" className="form-label ">
              Shipping Line
              </label>
              <input name="shipping_line_id"
                  id="shipping_line_id"
                  maxLength={250}
                  className="form-control form-control-sm "
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.shipping_line_id}
                  onInput={(event) => {
                    let value = event.target.value;
                    value = value.replace(/[^0-9]/g, '');
                    event.target.value = value;
                  }}
              />
            </div>
            <div className="col-md-6 mt-2">
              <label htmlFor="pickuptype" className="form-label ">
              Vessel Name
              </label>
              <input name="vessel_sailing_name"
                  id="vessel_sailing_name"
                  maxLength={250}
                  className="form-control form-control-sm "
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.vessel_sailing_name}
                  onInput={(event) => {
                    let value = event.target.value;
                    value = value.replace(/[^0-9]/g, '');
                    event.target.value = value;
                  }}
              />
            </div>
            <div className="col-md-6 mt-2">
              <label htmlFor="pickuptype" className="form-label ">
              Vessel Date
              </label>
              <input name="vessel_sailing_date"
                  id="vessel_sailing_date"
                  type="date"
                  maxLength={250}
                  className="form-control form-control-sm "
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.vessel_sailing_date}
                  onInput={(event) => {
                    let value = event.target.value;
                    value = value.replace(/[^0-9]/g, '');
                    event.target.value = value;
                  }}
              />
            </div>
            <div className="col-md-6 mt-2">
              <label htmlFor="pickuptype" className="form-label ">
              Voyage No
              </label>
              <input name="voyage_no"
                  id="voyage_no"
                  maxLength={250}
                  className="form-control form-control-sm "
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.voyage_no}
                  onInput={(event) => {
                    let value = event.target.value;
                    value = value.replace(/[^0-9]/g, '');
                    event.target.value = value;
                  }}
              />
            </div>
            <div className="col-md-6 mt-2">
              <label htmlFor="pickuptype" className="form-label ">
              IGM No
              </label>
              <input name="EGM_No"
                  id="EGM_No"
                  maxLength={250}
                  className="form-control form-control-sm "
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.EGM_No}
                  onInput={(event) => {
                    let value = event.target.value;
                    value = value.replace(/[^0-9]/g, '');
                    event.target.value = value;
                  }}
              />
            </div>
            <div className="col-md-6 mt-2">
              <label htmlFor="pickuptype" className="form-label ">
              IGM Date 
              </label>
              <input name="EGM_Date"
                  id="EGM_Date"
                  type="date"
                  maxLength={250}
                  className="form-control form-control-sm "
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.EGM_Date}
                  onInput={(event) => {
                    let value = event.target.value;
                    value = value.replace(/[^0-9]/g, '');
                    event.target.value = value;
                  }}
              />
            </div>
            <div className="col-md-6 mt-2">
              <label htmlFor="pickuptype" className="form-label ">
              Gross Wt 
              </label>
              <div className="d-flex gap-2">
              <input name="gross_weight"
                  id="gross_weight"
                  maxLength={250}
                  className="form-control form-control-sm "
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.gross_weight}
                  onInput={(event) => {
                    let value = event.target.value;
                    value = value.replace(/[^0-9]/g, '');
                    event.target.value = value;
                  }}
              />
              <select
                    className="form-control form-control-sm ms-2"
                    id="gross_weight_type"
                    name="gross_weight_type"
                    onChange={(e) => {
                      formik.setFieldValue("gross_weight_type", e.target.value);
                    }}
                    value={formik.values.gross_weight_type}
                  >
                    <option value="" disabled>-</option>
                    <option value="NOS">NOS</option>
                    <option value="BAG">BAG (Bags)</option>
                    <option value="BGS">BGS (BAGS)</option>
                    <option value="BLK">BLK (Bulk)</option>
                    <option value="BLO">BLO (Steel Blocks)</option>
                    <option value="BLS">BLS (Bails)</option>
                    <option value="BOX">BOX (Boxes)</option>
                    <option value="BRL">BRL (Barrel)</option>
                    <option value="BTL">BTL (Bottles)</option>
                    <option value="BUL">BUL (Steel Bulk)</option>
                    <option value="CAN">CAN (Cans)</option>
                    <option value="CHI">CHI (Chest)</option>
                    <option value="COL">COL (Collies)</option>
                    <option value="CON">CON (Container)</option>
                    <option value="CRI">CRI (Crates)</option>
                    <option value="CRY">CRY (Carboys)</option>
                    <option value="CSK">CSK (Wooden Cases)</option>
                    <option value="CTN">CTN (Cartons)</option>
                    <option value="CYL">CYL (Cylinder)</option>
                    <option value="DOZ">DOZ (Dozen)</option>
                    <option value="DRM">DRM (Drums)</option>
                    <option value="ENV">ENV (Steel Envelopes)</option>
                    <option value="FBK">FBK (Habbuck)</option>
                    <option value="FLK">FLK (Flask)</option>
                    <option value="FUT">FUT (Futs)</option>
                    <option value="GRS">GRS (Gross)</option>
                  </select>
              </div>
            </div>
            <div className="col-md-6 mt-2">
              <label htmlFor="pickuptype" className="form-label ">
              Net Wt
              </label>
              <div className="d-flex gap-2">
              <input name="net_weight"
                  id="net_weight"
                  maxLength={250}
                  className="form-control form-control-sm "
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.net_weight}
                  onInput={(event) => {
                    let value = event.target.value;
                    value = value.replace(/[^0-9]/g, '');
                    event.target.value = value;
                  }}
              />
              <select
                    className="form-control form-control-sm ms-2"
                    id="net_weight_type"
                    name="net_weight_type"
                    onChange={(e) => {
                      formik.setFieldValue("net_weight_type", e.target.value);
                    }}
                    value={formik.values.net_weight_type}
                  >
                    <option value="" disabled>-</option>
                    <option value="NOS">NOS</option>
                    <option value="BAG">BAG (Bags)</option>
                    <option value="BGS">BGS (BAGS)</option>
                    <option value="BLK">BLK (Bulk)</option>
                    <option value="BLO">BLO (Steel Blocks)</option>
                    <option value="BLS">BLS (Bails)</option>
                    <option value="BOX">BOX (Boxes)</option>
                    <option value="BRL">BRL (Barrel)</option>
                    <option value="BTL">BTL (Bottles)</option>
                    <option value="BUL">BUL (Steel Bulk)</option>
                    <option value="CAN">CAN (Cans)</option>
                    <option value="CHI">CHI (Chest)</option>
                    <option value="COL">COL (Collies)</option>
                    <option value="CON">CON (Container)</option>
                    <option value="CRI">CRI (Crates)</option>
                    <option value="CRY">CRY (Carboys)</option>
                    <option value="CSK">CSK (Wooden Cases)</option>
                    <option value="CTN">CTN (Cartons)</option>
                    <option value="CYL">CYL (Cylinder)</option>
                    <option value="DOZ">DOZ (Dozen)</option>
                    <option value="DRM">DRM (Drums)</option>
                    <option value="ENV">ENV (Steel Envelopes)</option>
                    <option value="FBK">FBK (Habbuck)</option>
                    <option value="FLK">FLK (Flask)</option>
                    <option value="FUT">FUT (Futs)</option>
                    <option value="GRS">GRS (Gross)</option>
                  </select>
              </div>
            </div>
            <div className="col-md-6 mt-2">
              <label htmlFor="pickuptype" className="form-label ">
              Volume
              </label>
              <div className="d-flex gap-2">
              <input name="volume_weight" 
                  id="volume_weight"
                  maxLength={250}
                  className="form-control form-control-sm "
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.volume_weight}
                  onInput={(event) => {
                    let value = event.target.value;
                    value = value.replace(/[^0-9]/g, '');
                    event.target.value = value;
                  }}
              />
              <select
                    className="form-control form-control-sm ms-2"
                    id="volume_weight_type"
                    name="volume_weight_type"
                    onChange={(e) => {
                      formik.setFieldValue("volume_weight_type", e.target.value);
                    }}
                    value={formik.values.volume_weight_type}
                  >
                    <option value="" disabled>-</option>
                    <option value="NOS">NOS</option>
                    <option value="BAG">BAG (Bags)</option>
                    <option value="BGS">BGS (BAGS)</option>
                    <option value="BLK">BLK (Bulk)</option>
                    <option value="BLO">BLO (Steel Blocks)</option>
                    <option value="BLS">BLS (Bails)</option>
                    <option value="BOX">BOX (Boxes)</option>
                    <option value="BRL">BRL (Barrel)</option>
                    <option value="BTL">BTL (Bottles)</option>
                    <option value="BUL">BUL (Steel Bulk)</option>
                    <option value="CAN">CAN (Cans)</option>
                    <option value="CHI">CHI (Chest)</option>
                    <option value="COL">COL (Collies)</option>
                    <option value="CON">CON (Container)</option>
                    <option value="CRI">CRI (Crates)</option>
                    <option value="CRY">CRY (Carboys)</option>
                    <option value="CSK">CSK (Wooden Cases)</option>
                    <option value="CTN">CTN (Cartons)</option>
                    <option value="CYL">CYL (Cylinder)</option>
                    <option value="DOZ">DOZ (Dozen)</option>
                    <option value="DRM">DRM (Drums)</option>
                    <option value="ENV">ENV (Steel Envelopes)</option>
                    <option value="FBK">FBK (Habbuck)</option>
                    <option value="FLK">FLK (Flask)</option>
                    <option value="FUT">FUT (Futs)</option>
                    <option value="GRS">GRS (Gross)</option>
                  </select>
              </div>
            </div>
            <div className="col-md-6 mt-2">
              <label htmlFor="pickuptype" className="form-label ">
              Chargeable Wt
              </label>
              <div className="d-flex gap-2">
              <input name="chargeable_weight"
                  id="chargeable_weight"
                  maxLength={250}
                  className="form-control form-control-sm "
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.chargeable_weight}
                  onInput={(event) => {
                    let value = event.target.value;
                    value = value.replace(/[^0-9]/g, '');
                    event.target.value = value;
                  }}
              />
              <select
                    className="form-control form-control-sm ms-2"
                    id="chargeable_weight_type"
                    name="chargeable_weight_type"
                    onChange={(e) => {
                      formik.setFieldValue("chargeable_weight_type", e.target.value);
                    }}
                    value={formik.values.chargeable_weight_type}
                  >
                    <option value="" disabled>-</option>
                    <option value="NOS">NOS</option>
                    <option value="BAG">BAG (Bags)</option>
                    <option value="BGS">BGS (BAGS)</option>
                    <option value="BLK">BLK (Bulk)</option>
                    <option value="BLO">BLO (Steel Blocks)</option>
                    <option value="BLS">BLS (Bails)</option>
                    <option value="BOX">BOX (Boxes)</option>
                    <option value="BRL">BRL (Barrel)</option>
                    <option value="BTL">BTL (Bottles)</option>
                    <option value="BUL">BUL (Steel Bulk)</option>
                    <option value="CAN">CAN (Cans)</option>
                    <option value="CHI">CHI (Chest)</option>
                    <option value="COL">COL (Collies)</option>
                    <option value="CON">CON (Container)</option>
                    <option value="CRI">CRI (Crates)</option>
                    <option value="CRY">CRY (Carboys)</option>
                    <option value="CSK">CSK (Wooden Cases)</option>
                    <option value="CTN">CTN (Cartons)</option>
                    <option value="CYL">CYL (Cylinder)</option>
                    <option value="DOZ">DOZ (Dozen)</option>
                    <option value="DRM">DRM (Drums)</option>
                    <option value="ENV">ENV (Steel Envelopes)</option>
                    <option value="FBK">FBK (Habbuck)</option>
                    <option value="FLK">FLK (Flask)</option>
                    <option value="FUT">FUT (Futs)</option>
                    <option value="GRS">GRS (Gross)</option>
                  </select>
              </div>
            </div>
            <div className="col-md-6 mt-2">
              <label htmlFor="pickuptype" className="form-label ">
              Marks & Nos
              </label>
              <input name="marks_Note"
                  id="marks_Note"
                  maxLength={250}
                  className="form-control form-control-sm "
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.marks_Note}
                  onInput={(event) => {
                    let value = event.target.value;
                    value = value.replace(/[^0-9]/g, '');
                    event.target.value = value;
                  }}
              />
            </div>
          </div>

            <div className="row d-flex justify-content-end mt-2">
              <div className="col-md-6 d-flex justify-content-end">
                <button type="submit" className="btn btn-sm btn-danger" disabled={disableSubmit}>
                  {disableSubmit ? <><i className="fas fa-spinner fa-spin"></i> Saving...</> : "Add"}
                </button>
              </div>
            </div>
          </form>
        </>
}
          
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default EditShipment
